import { render } from "./LessonsCreating.vue?vue&type=template&id=03edbe57&ts=true"
import script from "./LessonsCreating.vue?vue&type=script&lang=ts"
export * from "./LessonsCreating.vue?vue&type=script&lang=ts"

import "./LessonsCreating.vue?vue&type=style&index=0&id=03edbe57&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__